import { useGetApiV1SerieId } from '@/shared/api/generated';

/**
 * Hook para obter uma Série por ID.
 *
 * Envolve o hook gerado pelo Kubb para `GET /api/v1/serie/{id}`. Desabilitado
 * quando `serieId` é `undefined` (tela de criação).
 *
 * @param serieId - ID da série; omitir na criação
 *
 * @example
 * ```tsx
 * const { serie, isLoading } = useSerie(serieId);
 * ```
 */
export function useSerie(serieId: number | undefined) {
  const query = useGetApiV1SerieId(serieId as number, {
    query: { enabled: serieId !== undefined },
  });

  return {
    serie: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
